export class FailoverReqModel {
	public active: boolean;
	public type: string;
	public interval: number;
	public accounts: FailoverAccountReqModel[];

	constructor() {}

	public clone(source: any): FailoverReqModel {
		this.active = source.active;
		this.interval = source.interval ?? 0;
		this.type = source.type ?? '';

		if (source.accounts) {
			this.accounts = source.accounts.reduce((result, each) => {
				result.push(new FailoverAccountReqModel().clone(each));
				return result;
			}, []);
		}

		return this;
	}

	public convert(): any {
		return {
			failover: this,
		};
	}
}

class FailoverAccountReqModel {
	public accountId: string;
	public accountName: string;
	public subject: string;
	public platform: string;
	public template: {
		id: string;
		name: string;
		lang: string;
		data: string[];
	};

	constructor() {}

	public clone(source: any): FailoverAccountReqModel {
		this.accountId = source.accountId?.id ?? '';
		this.accountName = source.accountName ?? '';
		this.subject = source.subject ?? '';
		this.platform = source.platform ?? '';
		this.template = {
			id: source.template?.ID ?? '',
			name: source.template?.name ?? source.template ?? '',
			lang: source.template?.lang ?? '',
			data: source.paramBody?.map((t: any) => t.name) ?? [],
		};

		return this;
	}

	public convert(): any {
		return this;
	}
}
